import {HTMLProps} from 'react';

import styles from '@/components/css/Text.module.css';

type HeadingProps = HTMLProps<HTMLHeadingElement>;

export const LargeHeading = (props: HeadingProps) => (
  <h1 {...props} className={styles.largeHeading}>
    {props.children}
  </h1>
);

export const MediumHeading = (props: HeadingProps) => (
  <h2 {...props} className={styles.mediumHeading}>
    {props.children}
  </h2>
);

export const SmallHeading = (props: HeadingProps) => (
  <h3 {...props} className={styles.smallHeading}>
    {props.children}
  </h3>
);

export const BodyText = (props: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={styles.bodyText}>
    {props.children}
  </div>
);

export const BodySmall = (props: HTMLProps<HTMLDivElement>) => (
  <div {...props} className={styles.bodySmall}>
    {props.children}
  </div>
);
